export default ({ route, redirect }) => {
  if (route.path === '/' || !route.path.endsWith('/')) return;

  const { path, query, hash } = route;
  const nextPath = path.slice(0, -1);
  const nextRoute = { path: nextPath, query, hash };

  redirect(301, nextRoute);
};
